import type { IWorkspace } from '@/types/api';

/**
 * Case-insensitive substring filter on workspace name. An empty or
 * whitespace-only query returns the list unchanged. Pure — safe to call on
 * every render.
 */
export function filterWorkspacesByName(
  workspaces: readonly IWorkspace[],
  query: string,
): IWorkspace[] {
  const trimmed = query.trim().toLowerCase();
  if (trimmed.length === 0) return [...workspaces];
  return workspaces.filter((workspace) => workspace.name.toLowerCase().includes(trimmed));
}
